/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable prettier/prettier */
import PropTypes from 'prop-types';
import { useState, createContext, useEffect, useReducer } from 'react';

// third-party
// import firebase from 'firebase/compat/app';
// import 'firebase/compat/auth';
import { initializeApp } from 'firebase/app';
import { createUserWithEmailAndPassword, getAuth, GoogleAuthProvider, onAuthStateChanged, sendPasswordResetEmail, signInWithEmailAndPassword, signInWithPopup, signOut, TwitterAuthProvider } from 'firebase/auth';
import { ReactSession } from 'react-client-session';

// action - state management
import { LOGIN, LOGOUT } from 'store/actions';
import accountReducer from 'store/accountReducer';

// project imports
import Loader from 'ui-component/Loader';
import { FIREBASE_API } from 'config';
import TweetsyConfig from 'TweetsyConfig';
import axios from 'axios';

ReactSession.setStoreType("localStorage");

// firebase initialize
// if (!firebase.apps.length) {
//     firebase.initializeApp(FIREBASE_API);
// }
initializeApp(FIREBASE_API);

const auth = getAuth();
const twitterProvider = new TwitterAuthProvider();

// const
const initialState = {
    isLoggedIn: false,
    isInitialized: false,
    user: null
};

// ==============================|| FIREBASE CONTEXT & PROVIDER ||============================== //

const FirebaseContext = createContext(null);

export const FirebaseProvider = ({ children }) => {
    const [state, dispatch] = useReducer(accountReducer, initialState);
    const [dbUser, setDbUser] = useState(ReactSession.get('dbuser') || {});
    const [dbLoginUser, setDbLoginUser] = useState(ReactSession.get("dbloginuser") || {})
    const [likedTweet, setLikedTweet] = useState([])
    const [twitter, setTwitter] = useState(ReactSession.get("twitter") || {})
    const [repliedTweet, setRepliedTweet] = useState([])
    const [skippedTweet, setSkippedTweet] = useState(ReactSession.get("skippedTweet") || [])
    const [isExpired, setIsExpired] = useState(false);

    // exfired count
    useEffect(() => {
        if (dbLoginUser.end_date) {
            const endDateValue = new Date(dbLoginUser.end_date).valueOf();
            const currentDateValue = new Date().valueOf();
            if (currentDateValue > endDateValue) return setIsExpired(true);
        }
    }, [dbLoginUser])



    // Twitter signIn/signUp
    const twitterSignIn = () => {
        signInWithPopup(auth, twitterProvider)
            .then((result) => {
                console.log("🧪 MAIN RESULT FROM TWITTER ", result);

                const { user: { uid }, _tokenResponse: { oauthAccessToken, oauthTokenSecret, displayName, email, screenName, photoUrl } } = result;

                const twitterObj = { uid, displayName, screenName, email, photoUrl }
                setTwitter(twitterObj);
                ReactSession.set("twitter", twitterObj);

                // loginCounter
                axios.get(`${TweetsyConfig.getNodeUrl()}countLogin/${uid}/${screenName}`)
                    .then(res => {
                        console.log('login counted: ', res.data.acknowledged)
                    }).catch(err => {
                        console.error('error from countLogin get:', err);
                    })


                fetch(`${TweetsyConfig.getNodeUrl()}sessions/callback/${oauthAccessToken}/${oauthTokenSecret}/${uid}/${email}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    },
                })
                    .then(res => res.json())
                    .then(data => {
                        console.log('❤❤❤ Response from callback: \n', data) // get user info - user, login-user
                        // TODO: set user & login user data on state
                        ReactSession.set("dbuser", data.user);
                        setDbUser(data.user);
                        ReactSession.set("dbloginuser", data.login_user);
                        setDbLoginUser(data.login_user)
                        ReactSession.set("skippedTweet", data.user.skippedTweet);
                        setSkippedTweet(data.user.skippedTweet)


                    }).catch(err => {
                        console.log('🤦‍♂️Got error from callback:\n', err)
                    })


                // setAuthError('')
            })
            .catch((error) => {
                // console.log(error);
                console.dir(error);
                // setAuthError(error.code)
            })
            .finally(() => {
                console.log('Twitter auth done; finally block executed.')
                // setIsLoading(false)
            })
    }

    useEffect(
        () =>
            onAuthStateChanged(auth, (user) => {
                console.log('🧪 User form observer\n', user)
                console.log('🧪 State form observer\n', state)
                if (user) {



                    dispatch({
                        type: LOGIN,
                        payload: {
                            isLoggedIn: true,
                            user: {
                                id: user.uid,
                                email: user.email,
                                name: user.displayName,
                                image: user.photoURL
                            }
                        }
                    });
                } else {
                    dispatch({
                        type: LOGOUT
                    });
                    // localstorage cleaneup.
                    localStorage.clear();
                }
            }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [dispatch]
    );


    useEffect(() => {
        if (state?.user?.id && dbUser?._id) {
            console.log('🧪 state', state)
            // }
            // if (dbUser?._id) {
            console.log('🧪 dbUser', dbUser)
            // }


            // get Liked tweet
            axios.get(`${TweetsyConfig.getNodeUrl()}likedtweets/${state.user.id}`)
                .then(res => {
                    console.log('🧪 liked', res.data)
                    setLikedTweet(res.data)
                })
                .catch((err) => {
                    console.log('error from likeed tweet:\n', err)
                })
            // get replyed
            axios.get(`${TweetsyConfig.getNodeUrl()}user/replydata/${state.user.id}`)
                .then(res => {
                    console.log('🧪 liked', res.data)
                    setRepliedTweet(res.data)
                })
                .catch((err) => {
                    console.log('error from likeed tweet:\n', err)
                })
        }

    }, [state, dbUser])


    const logout = () => signOut(auth);







    // ==================================================
    // old code for old email based auth START; no need of those  
    // ==================================================

    const firebaseEmailPasswordSignIn = (email, password) => signInWithEmailAndPassword(email, password);

    const firebaseGoogleSignIn = () => {
        const provider = new GoogleAuthProvider();

        return signInWithPopup(provider);
    };

    const firebaseRegister = async (email, password) => createUserWithEmailAndPassword(email, password);


    const resetPassword = async (email) => {
        await sendPasswordResetEmail(email);
    };

    const updateProfile = () => { };
    if (state.isInitialized !== undefined && !state.isInitialized) {
        return <Loader />;
    }

    return (
        <FirebaseContext.Provider
            value={{
                ...state,
                firebaseRegister,
                firebaseEmailPasswordSignIn,
                login: () => { },
                firebaseGoogleSignIn,
                logout,
                resetPassword,
                updateProfile,
                // TWEETSY CUSTOM FUNCTION
                twitterSignIn,
                dbUser,
                setDbUser,
                dbLoginUser,
                setDbLoginUser,
                twitter,
                // liked tweet
                likedTweet,
                setLikedTweet,
                // replyed tweet
                repliedTweet,
                setRepliedTweet,
                // skipped niche tweet
                skippedTweet,
                setSkippedTweet,
                // common
                isExpired
            }}
        >
            {children}
        </FirebaseContext.Provider>
    );
};

FirebaseProvider.propTypes = {
    children: PropTypes.node
};

export default FirebaseContext;
